import MenuYearBilling from './MenuYearBilling.view';

export default MenuYearBilling;
